export default function (
  category: string,
  action: string,
  name: string = '',
  value: string = ''
) {
  if (window._paq && process.client) {
    window._paq.push(['trackEvent', category, action, name, value])
  }
}
